import React from "react";
import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../Componentes/Basicos/LVGridDetalle";

class CON_Asientos_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true
    };
  }
 
  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { CON_Asientos: { function_CON_Asientos_Leer } } = require('neftis7_apicaller');
      const resultData = await function_CON_Asientos_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdAsiento)
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItems ? null : (
          <>
            {this.state.data && this.state.data.Detalles && this.state.data.Detalles.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.Detalles}
                  Titulo="Items"
                >
                  <Summary>
                    <TotalItem
                      column="ImporteDebe"
                      summaryType="sum"
                      customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                      valueFormat="currency" />

                    <TotalItem
                      column="ImporteHaber"
                      summaryType="sum"
                      customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                      valueFormat="currency" />

                  </Summary>
                  <Column caption="Cuenta Contable" alignment="Center">
                    <Column caption="Código" dataField="CodigoCuentaContable" width="120" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="I_CuentaContable" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="DEBE" dataField="ImporteDebe" width="100" alignment="Right" dataType="number" format="currency" />
                  <Column caption="HABER" dataField="ImporteHaber" width="100" alignment="Right" dataType="number" format="currency" />

                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}
      </React.Fragment>
    );
  }
}

export default CON_Asientos_Detalle;
